module.exports = __webpack_public_path__ + "static/media/main_visual_agriculture_telehandler_mlt_420_60_h_manitou.73ef7feb.png";